import {
  ORDENESTUDIO_ERROR,
  ORDENESTUDIO_LOADING,
  ORDENESTUDIO_SUCCESS,
  ORDENESTUDIO_RESET,
  ORDENESTUDIO_ELIMINAR,
  RESET_PORTAL_CONTEXT
} from "../ActionTypes";

import ordenEstudioInitialState from "../initialStates/ordenEstudioInitialState";

const ordenEstudio = (state, { payload, type }) => {
  switch (type) {
    case ORDENESTUDIO_LOADING:
      return {
        ...state,
        ordenEstudio: {
          ...state.ordenEstudio,
          error: false,
          loading: true,
        },
      };
    case ORDENESTUDIO_SUCCESS:
      return {
        ...state,
        ordenEstudio: {
          ...state.ordenEstudio,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case ORDENESTUDIO_ELIMINAR:
      return {
        ...state,
        ordenEstudio: {
          ...state.ordenEstudio,
          loading: false,
          error: false,
          eliminado: payload,
        },
      };
    case ORDENESTUDIO_ERROR:
      return {
        ...state,
        ordenEstudio: {
          ...state.ordenEstudio,
          error: payload,
          loading: false,
        },
      };

    case ORDENESTUDIO_RESET:
      return ordenEstudioInitialState;
    case RESET_PORTAL_CONTEXT:
      return ordenEstudioInitialState;

    default:
      return state;
  }
};

export default ordenEstudio;
